import { Tooltip, TooltipContent, TooltipTrigger } from '@playbooks/ui/components/tooltip';
import { cn } from '@playbooks/ui/lib/utils';

const statusDotColor = status => {
	switch (status?.toString().toLowerCase()) {
		case 'draft':
		case 'closed':
		case 'inactive':
		case 'stopped':
			return 'bg-foreground-body';
		case 'pending':
			return 'bg-warning';
		case 'modified':
		case 'warning':
		case 'paused':
			return 'bg-warning';
		case 'info':
		case 'active':
		case 'complete':
		case 'succeeded':
		case 'verified':
			return 'bg-success';
		case 'canceled':
		case 'denied':
		case 'disabled':
		case 'errored':
		case 'refunded':
			return 'bg-danger';
		case 'published':
		case 'finished':
		case 'paid':
		case 'won':
		default:
			return 'bg-foreground';
	}
};
const StatusDot = ({ status, html = null, className = '', ...props }) => {
	// Theme
	const rootClassName = cn(statusDotColor(status), 'size-3 rounded-full border-2 border-canvas', className);

	// Render
	if (!status) return null;
	const dot = <span className={rootClassName} aria-label={status} {...props} />;
	if (!html) return dot;
	return (
		<Tooltip>
			<TooltipTrigger render={dot} />
			<TooltipContent>{html}</TooltipContent>
		</Tooltip>
	);
};
export { StatusDot, statusDotColor };
